// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link[data-v-cbc97740]{cursor:pointer}", "",{"version":3,"sources":["webpack://./resources/components/table/LinkFriendCell.vue"],"names":[],"mappings":"AAIA,uBACE,cAHF","sourcesContent":["@import \"../../scss/variables/color\";\n@import \"../../scss/variables/container-max-widths\";\n\n\n.link {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
